var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-alert',{staticClass:"result-alert",attrs:{"message":"重置密码","description":"成功","type":"info","show-icon":""}}),_c('a-button',{attrs:{"type":"primary","size":"large","block":""},on:{"click":function($event){return _vm.$emit('go-login')}}},[_vm._v(" 前往登录 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }